(function ($, Drupal, once) {

  /* Logic to switch between tabs for content displayed on a single page */
  Drupal.behaviors.mitosIconSizing = {

    attach: function (context, settings) {

      const iconEl = $(".main-paragraph-wrapper .field--name-field-statistic-icon");

      if (iconEl.length) {

        var nums = [];
        iconEl.each( function() {
          var iconHeight = $(this).outerHeight();
          nums.push( iconHeight );
        });
        var max = Math.max.apply(Math, nums);


        iconEl.each( function() {
          $(this).css('height',max + 'px')
        });

      }

    }
  };
}(jQuery, Drupal, once));
